<template>
  <div class="reply-content-off-site-mailbox">
    <mailbox-nav-bar ref="mailboxNavBar" @treeItemClick="treeItemClick"></mailbox-nav-bar>
    <mailbox-list
      ref="mailboxList"
      :loading="listLoading"
      :total="total"
      :emailId="params.model.emailId"
      :mailboxList="mailboxList"
      @changeParmas="changeParmas"
      :size="size"
      @cellHandler="cellHandler"
      @readAllSuccess="readAllSuccess"
      :type="params.model.type"
    ></mailbox-list>
    <mailbox-content
      :detail="detail"
      :remainingMail="remainingMail"
      @emailCollection="emailCollection"
      @reSendSuccess="reSendSuccess"
      @saveDraftEmail="saveDraftEmail"
    ></mailbox-content>
  </div>
</template>

<script>
import MailboxNavBar from './mailbox-nav-bar';
import MailboxList from './mailbox-list';
import MailboxContent from './mailbox-content';
import { outTicketItemList, getOutTicketItemDetail } from '@/api/crm.js';
import {convertToFullDate} from "@/utils/date.util";
import { getRemainingMail } from '@/api/common';
export default {
  name: 'reply-off-site-mailbox',
  components: { MailboxNavBar, MailboxList, MailboxContent },
  props: {
    content: String,
    outStatus: String,
  },
  data() {
    return {
      listLoading: false,
      total: 0,
      size: 20,
      mailboxList: [],
      emailData: {},
      detail: {},
      remainingMail: 0,
      emailParmas: {},
      params: {
        model: {
          readed: 'all',
          content: this.content,
          outStatus: this.outStatus,
        },
        order: 'descending',
        size: 20,
        current: 1,
      },
    };
  },
  watch: {
    content: function () {
      this.params.model.content = this.content;
    },
    outStatus: function () {
      this.params.model.outStatus = this.outStatus;
    },
  },
  methods: {
    saveDraftEmail() {
      this.$refs.mailboxNavBar.getoutEmailList('click');
    },
    //  全部已读
    readAllSuccess() {
      this.$refs.mailboxNavBar.getoutEmailList('click');
      this.$emit('outTicketItemUnread');
    },
    //重发成功
    reSendSuccess() {
      this.$refs.mailboxNavBar.getoutEmailList('click');
      this.mailboxList = [];
      this.detail = {};
    },
    // 收藏邮件回调
    emailCollection() {
      this.$refs.mailboxNavBar.getoutEmailList('click');
    },
    cellHandler(index, item, target) {
      if (target) {
        this.$emit('outTicketItemUnread');
        this.$refs.mailboxNavBar.getoutEmailList('click');
      }
      this.mailboxList.splice(index, 1, {...this.mailboxList[index],active:true })
      getRemainingMail().then((res) => {
        this.remainingMail = res;
      });
      this.detail = item;
    },
    // 参数改变回调
    changeParmas(data) {
      this.params.model.readed = data.readed;
      this.params.order = data.order;
      this.params.current = data.current;
      this.outTicketItemList();
    },
    // 查询邮件
    treeItemClick(data, type) {
      this.params.model.emailId = data.emailId;
      this.params.model.type = data.type;
      this.outTicketItemList(type);
    },
    initParams() {
      this.$refs.mailboxList.initParams();
    },
    // 查询邮件接口调用
    outTicketItemList(type) {
      const vm = this;
      this.listLoading = true;
      vm.params.sort = vm.params.model.type == 'Drafts' ? 'updateTime' : 'createTime'
      outTicketItemList(vm.params)
        .then((res) => {
          let arr = res.data.records;
          vm.total = res.data.total;
          arr.forEach((item) => {
            item.checked = false;
            item.active = false;
            item.hasCheckbox = false;
            item.simpleEmailTime = convertToFullDate(item.emailTime, 'MM-dd');
            item.simpleUpdateTime = convertToFullDate(item.updateTime, 'MM-dd');
          });
          vm.mailboxList = arr;
          if (type == 'click' && arr.length) {
            this.$refs.mailboxList.cellHandler(
              this.$refs.mailboxList.index,
              arr[this.$refs.mailboxList.index],
            );
          } else {
            this.detail = {};
          }
        })
        .complete(() => (this.listLoading = false));
    },
  },
};
</script>

<style lang="scss">
.reply-content-off-site-mailbox {
  border: 1px solid #D8DADD;
  .reply-left {
    float: left;
  }

  .reply-right {
    float: right;
  }

  height: 100%;
  display: flex;
  box-sizing: border-box;
  border-top: 1px solid #d8dadd;
}
</style>
